import React, { useState } from "react"
import withStyles from "react-jss"
import { SMALL_MOBILE_BREAKPOINT } from "../../data/globalStyles"
import { infoIcon } from "../../assets"
import colors from "../../data/colors"

const styles = {
  headingContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // zIndex: 2,
  },
  heading: {
    fontFamily: "Futura!important",
    fontWeight: "700!important",
    fontSize:
      "calc(22px + (26 - 22) * ((100vw - 300px) / (1600 - 300)))!important",
    margin: 0,
  },
  tooltipContainer: {
    position: "relative",
    marginLeft: "1.5rem",
  },
  infoIcon: {
    height: "15px",
    width: "15px",
  },
  subHeading: {
    fontFamily: "Georgia!important",
    fontWeight: "400!important",
    fontSize:
      "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))!important",
    padding: "0 0 2rem 0",
    marginBottom: 0,
    // zIndex: 2,
  },
  descriptionBoxCockTail: {
    width: "97.5%",
    padding: "1rem 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderTop: `1px solid ${colors.infoOrangeUnderline}`,
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  orBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  or: {
    fontFamily: "Futura",
    fontWeight: "700",
    fontSize: "10px",
    lineHeight: "1.2em",
    color: "#000000",
  },
  orBorder: {
    borderBottom: `1px solid ${colors.infoOrangeUnderline}`,
    width: "94%",
    margin: "0 0 0 1em",
  },
  descriptionBoxRecipe: {
    width: "97.5%",
    padding: "1rem 0",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: "2rem",
    borderBottom: `1px solid ${colors.infoOrangeUnderline}`,
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  descriptionHeader: {
    fontFamily: "Futura",
    fontWeight: 700,
    fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
    textAlign: "left",
    textTransform: "uppercase",
    overflowWrap: "break-word",
    width: "30%",
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      width: "80%",
      margin: "0 0 0.5rem 0",
    },
  },
  descriptionInfo: {
    maxWidth: "70%",
    fontFamily: "Georgia",
    fontSize: "calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)))",
    textAlign: "left",
    overflowWrap: "break-word",
    lineHeight: 1.2,
    margin: 0,
    [`@media only screen and (max-width: ${SMALL_MOBILE_BREAKPOINT}px)`]: {
      maxWidth: "90%",
    },
  },
  tooltip: {
    position: "absolute",
    top: 0,
    left: 30,
    "@media only screen and (max-width : 970px)": {
      top: 70,
      left: -250,
    },
    fontFamily: "Jost",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize:
      "calc(12px + (14 - 12) * ((100vw - 300px) / (1600 - 300)))!important",
    lineHeight: 1.4,
    width: "250px",
    color: colors.black,
    border: `1px solid ${colors.infoOrangeUnderline}`,
    background: colors.tooltipBackgroundOrange,
    padding: "0.7rem",
    margin: "-3.5em 0 0 0",
    pointerEvents: "none",
    zIndex: 5,
  },
}

const Information = ({ classes }) => {
  const [showpopup, setshowpopup] = useState(false)
  return (
    <>
      <title className={classes.headingContainer}>
        <h2 className={classes.heading}>
          Build a drink and we’ll tell you its ABV
        </h2>
        <div className={classes.tooltipContainer}>
          <img
            src={infoIcon}
            className={classes.infoIcon}
            onMouseEnter={() => setshowpopup(true)}
            onMouseLeave={() => setshowpopup(false)}
            alt="Information icon."></img>
          {showpopup ? (
            <div className={classes.tooltip}>
              Alcohol by volume (ABV) is a metric used to determine the alcohol
              content in an alcoholic beverage. The measurement shows what
              percentage of the beverage’s total volume is pure alcohol.
            </div>
          ) : null}
        </div>
      </title>
      <h4 className={classes.subHeading}>
        Start with a classic cocktail, or enter your own ingredients.
      </h4>
      <div className={classes.descriptionBoxCockTail}>
        <p className={classes.descriptionHeader}>Select a cocktail</p>
        <p className={classes.descriptionInfo}>
          The form will automatically fill out with the correct ingredients and
          volume data if you select a cocktail from our database.
        </p>
      </div>
      <div className={classes.orBox}>
        <div className={classes.or}>OR</div>
        <div className={classes.orBorder}></div>
      </div>
      <div className={classes.descriptionBoxRecipe}>
        <p className={classes.descriptionHeader}>Build a custom recipe</p>
        <p className={classes.descriptionInfo}>
          Remember to add all ingredients, not just the alcohol, as everything
          in the glass will impact the final ABV.
        </p>
      </div>
    </>
  )
}

export default withStyles(styles)(Information)
